"use client";

import type { ThemeProviderProps } from "next-themes";
import { ThemeProvider as ThemeProviderOriginal } from "next-themes";

export default function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <ThemeProviderOriginal {...props}>{children}</ThemeProviderOriginal>;
}
